<template>
  <modal ref="modal"
    :playground="true"
    :title="title"
    @show="focusPrimaryInput"
    @hidden="resetForm">
    <div class="uk-modal-body">
      <legal-text-picker
        ref="primaryInput"
        v-model="newLegalTexts"
        :filter="filter"
        :disabled="disabled"
        @selectionConfirmed="submit"
      />
    </div>
    <div class="uk-modal-footer uk-text-right">
      <common-button type="primary" :disabled="disabled" @click="submit">
        {{$t('actions.add')}}
      </common-button>
      <common-button @click="hide">
        {{$t('actions.cancel')}}
      </common-button>
    </div>
  </modal>
</template>

<script>
import CommonButton from '@/components/CommonButton';
import Modal from '@/components/Modal';
import LegalTextPicker from '@/components/LegalTextPicker';

export default {
  name: 'legal-text-picker-modal',
  data() {
    return {
      newLegalTexts: [],
      modalOpen: false,
    };
  },
  computed: {
    omittedIds() {
      if (!this.selectedLegalTexts) return [];
      return this.selectedLegalTexts.map(legal => legal.id)
                                    .sort();
    },
    filter() {
      return {
        omittedIds: this.omittedIds,
      };
    },
  },
  props: {
    title: String,
    selectedLegalTexts: {
      type: Array,
      default: () => [],
    },
    addLegalTexts: {
      type: Function,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CommonButton,
    Modal,
    LegalTextPicker,
  },
  methods: {
    show() {
      this.modalOpen = true;
      this.$refs.modal.show();
    },
    hide() {
      this.modalOpen = false;
      this.$refs.modal.hide();
    },
    resetForm() {
      this.newLegalTexts = [];
    },
    submit() {
      this.$emit('onSelect', this.newLegalTexts);
      this.hide();
    },
    focusPrimaryInput() {
      this.$refs.primaryInput.focus();
    },
  },
  watch: {
    selectedLegalTexts(legalTexts) {
      this.selectedLegalTexts = legalTexts;
    },
  },
  i18n: {
    messages: {
      de: {
        fields: {
          legalText: 'Rechtstext',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// LegalTextPickerModal.vue?3f8ba439